import Icon from '../components/Icon.vue'

Icon.register({
  'expand-arrows-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 344v112 0.1c0 13.2-10.7 23.9-23.9 23.9h-0.1-112c-21.4 0-32.1-25.9-17-41l36.2-36.2-107.2-107.2-107.2 107.3 36.2 36.1c15.1 15.1 4.4 41-17 41h-112-0.1c-13.2 0-23.9-10.7-23.9-23.9v-0.1-112c0-21.4 25.9-32.1 41-17l36.2 36.2 107.3-107.2-107.3-107.3-36.2 36.3c-15.1 15.1-41 4.4-41-17v-112-0.1c0-13.2 10.7-23.9 23.9-23.9h0.1 112c21.4 0 32.1 25.9 17 41l-36.2 36.2 107.2 107.2 107.2-107.3-36.2-36.1c-15.1-15.1-4.4-41 17-41h112 0.1c13.2 0 23.9 10.7 23.9 23.9v0.1 112c0 21.4-25.9 32.1-41 17l-36.2-36.2-107.3 107.2 107.3 107.3 36.2-36.2c15.1-15.2 41-4.5 41 16.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/expand-arrows-alt.js
// module id = 1312
// module chunks = 0